/* eslint-env browser, jquery */
import 'bootstrap';
import domify from 'domify';
import page from 'modules/ab-page-js';
import $ from 'jquery';
import scrollIntoView from 'scroll-into-view';
import ContactForm from 'auth0-contact-form';
import { ContactUsForm } from 'components';
import { render as clientRender, unmountComponentAtNode } from 'react-dom';
import React from 'react';
import Animation from 'modules/animation-timeline';
import AnimationScroll from 'modules/animation-scroll';
import container from 'modules/section-content';
import splash from './view/landing.pug';
import metadata from './metadata.json';

const animationScroll = new AnimationScroll();
const metricsLib = window.metricsLib;

export default function register() {
  page('/b2b-saas', render, snippets);
  page.exit('/b2b-saas', unmountContactForm, resetAnimation);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  /* eslint-env browser */
  clientRender(
    <ContactUsForm
      source="b2b-saas"
      subject="New lead from B2B SaaS landing page"
      formId="b2b-saas-contact-form"
    />,
    document.querySelector('.contact-us-app')
  );
  return next();
}

function snippets(ctx, next) {
  setupClickHandlers();
  setupContactForm();
  setupAnimations();
  next();
}

function setupClickHandlers() {
  const frictionlessTargetElem = document.getElementById('scroll-spy-frictionless');
  const extensibleTargetElem = document.getElementById('scroll-spy-extensible');
  const secureTargetElem = document.getElementById('scroll-spy-secure');
  const adaptiveTargetElem = document.getElementById('scroll-spy-adaptive');

  const $frictionlessSection = $('.b2b-saas-page section[role="navigation"] .section-frictionless');
  const $extensibleSection = $('.b2b-saas-page section[role="navigation"] .section-extensible');
  const $secureSection = $('.b2b-saas-page section[role="navigation"] .section-secure');
  const $adaptiveSection = $('.b2b-saas-page section[role="navigation"] .section-adaptive');

  $frictionlessSection.on('click', () => scrollIntoView(frictionlessTargetElem, { time: 500 }));
  $extensibleSection.click(() => scrollIntoView(extensibleTargetElem, { time: 500 }));
  $secureSection.click(() => scrollIntoView(secureTargetElem, { time: 500 }));
  $adaptiveSection.click(() => scrollIntoView(adaptiveTargetElem, { time: 500 }));
}

function setupContactForm() {
  const salesContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:b2b-contact-form', metricsData);
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:b2b-contact-form', metricsData);
    },
    source: 'b2b-saas'
  };
  const salesContactForm = new ContactForm(salesContactFormOptions);

  const salesFormButton = document.querySelector('.open-contact-form-modal');
  salesFormButton.addEventListener('click', () =>
    salesContactForm.show({ includePhoneField: true })
  );
}

function setupAnimations() {
  const heroAnimation = setupHeroAnimation();
  const frictionlessAnimation = setupFrictionlessAnimation();
  const extensibleAnimation = setupExtensibleAnimation();
  const secureAnimation = setupSecureAnimation();
  const adaptiveAnimation = setupAdaptiveAnimation();
  const $navigation = $('#b2b-saas-page-navigation');
  const $frictionlessSection = $('#b2b-saas-page-navigation .section-frictionless span');
  const $extensibleSection = $('#b2b-saas-page-navigation .section-extensible span');
  const $secureSection = $('#b2b-saas-page-navigation .section-secure span');
  const $adaptiveSection = $('#b2b-saas-page-navigation .section-adaptive span');

  heroAnimation.run();
  animationScroll.add({
    id: 'frictionless-section',
    animation: frictionlessAnimation,
    options: { offsetTop: -60, oneShot: true }
  });
  animationScroll.add({
    id: 'extensible-section',
    animation: extensibleAnimation,
    options: { offsetTop: -60, oneShot: true }
  });
  animationScroll.add({
    id: 'secure-section',
    animation: secureAnimation,
    options: { offsetTop: -60, oneShot: true }
  });
  animationScroll.add({
    id: 'adaptive-section',
    animation: adaptiveAnimation,
    options: { offsetTop: -60, oneShot: true }
  });
  animationScroll.addScrollSpy({
    id: 'scroll-spy-container',
    onEnter: () => $navigation.addClass('fixed'),
    onLeave: () => $navigation.removeClass('fixed')
  });
  animationScroll.addScrollSpy({
    id: 'scroll-spy-frictionless',
    onEnter: () => $frictionlessSection.addClass('section-active'),
    onLeave: () => $frictionlessSection.removeClass('section-active'),
    options: { offsetTop: -140 }
  });
  animationScroll.addScrollSpy({
    id: 'scroll-spy-extensible',
    onEnter: () => $extensibleSection.addClass('section-active'),
    onLeave: () => $extensibleSection.removeClass('section-active')
  });
  animationScroll.addScrollSpy({
    id: 'scroll-spy-secure',
    onEnter: () => $secureSection.addClass('section-active'),
    onLeave: () => $secureSection.removeClass('section-active')
  });
  animationScroll.addScrollSpy({
    id: 'scroll-spy-adaptive',
    onEnter: () => $adaptiveSection.addClass('section-active'),
    onLeave: () => $adaptiveSection.removeClass('section-active')
  });

  animationScroll.start();
}

function setupHeroAnimation() {
  const $elem = $('.b2b-saas-page section[role="hero"] .hero-animation');
  const animation = new Animation($elem);

  return animation
    .addClass('initial')
    .removeClass('step-01 step-02 step-03 step-04 step-05 step-06')
    .fadeIn(300)
    .delay(400)
    .toggleClass('step-01')
    .delay(300)
    .toggleClass('step-02')
    .delay(450)
    .toggleClass('step-03')
    .delay(300)
    .toggleClass('step-04')
    .delay(900)
    .toggleClass('step-05')
    .delay(200)
    .toggleClass('step-06')
    .delay(200)
    .toggleClass('step-07')
    .delay(100)
    .toggleClass('step-08')
    .delay(100)
    .toggleClass('step-09')
    .delay(200)
    .toggleClass('step-10')
    .delay(100)
    .toggleClass('step-11')
    .delay(200)
    .toggleClass('step-12')
    .delay(100)
    .toggleClass('step-13')
    .delay(200)
    .toggleClass('step-14');
}

function setupFrictionlessAnimation() {
  const $elem = $('.b2b-saas-page section[role="frictionless"] .frictionless-animation');
  const animation = new Animation($elem);

  return animation
    .fadeIn(300)
    .addClass('initial')
    .removeClass('sso-button-click sso-loading sso website-loading website')
    .keyboardType('john@acmeinc.com', 'data-username')
    .delay(300)
    .toggleClass('sso-loading')
    .delay(500)
    .toggleClass('initial sso-loading sso')
    .delay(1300)
    .toggleClass('sso-button-click')
    .delay(500)
    .toggleClass('sso-button-click website-loading')
    .delay(800)
    .toggleClass('sso website-loading website');
}

function setupExtensibleAnimation() {
  const $elem = $('.b2b-saas-page section[role="extensible"] .extensible-animation');
  const animation = new Animation($elem);

  return animation.addClass('initial').delay(350).toggleClass('callout-1');
}

function setupSecureAnimation() {
  const $elem = $('.b2b-saas-page section[role="secure"] .secure-animation');
  const animation = new Animation($elem, { oneShot: true });

  return animation
    .toggleClass('circle-1 mobile')
    .delay(70)
    .toggleClass('circle-2')
    .delay(70)
    .toggleClass('circle-3')
    .delay(70)
    .toggleClass('circle-4')
    .delay(500)
    .toggleClass('callout-1')
    .delay(500)
    .toggleClass('callout-2')
    .delay(500)
    .toggleClass('callout-3');
}

function setupAdaptiveAnimation() {
  const $elem = $('.b2b-saas-page section[role="adaptive"] .adaptive-animation');
  const animation = new Animation($elem, { oneShot: true });

  return animation.toggleClass('callout-1').delay(500).toggleClass('callout-2');
}

function unmountContactForm(ctx, next) {
  unmountComponentAtNode(document.querySelector('.contact-us-app'));
  next();
}

function resetAnimation(ctx, next) {
  animationScroll.reset();
  next();
}



// WEBPACK FOOTER //
// ./src/pages/b2b-saas/client.js